import React from 'react';
import { useTranslation } from 'react-i18next';
import { setPlanModalOpen } from '../store/uiModalStore';
import { capOf } from '../services/vaultCloudCap';
import './VaultCapMeter.css';

/**
 * "x of N items in your cloud vault" under Settings → Vault → Cloud copy
 * (card U1). Shown only when the plan has a cap and the vault is in the
 * cloud; a hint from 80 %, and after a downgrade (more than N stored) it says
 * what still works: everything stored stays, only NEW items wait.
 */
export default function VaultCapMeter({ consent }) {
  const { t } = useTranslation();
  const cap = capOf(consent);
  if (!cap.cloud || cap.max == null) return null;
  const pct = Math.min(100, Math.round((cap.items / cap.max) * 100));

  let hint = null;
  if (cap.over) {
    hint = t(
      'vault.capOver',
      'Your cloud vault holds more than the Free plan keeps. Everything stored stays and syncs; new items can be kept on this device until there is room.'
    );
  } else if (cap.full) {
    hint = t('vault.capFullHint', 'Your free cloud vault is full. New items can stay on this device only, or upgrade for unlimited.');
  } else if (cap.nearlyFull) {
    hint = t('vault.capNearlyFull', 'Your free cloud vault is nearly full.');
  }

  return (
    <div className="vault-cap-meter" data-testid="vault-cap-meter">
      <div className="vault-cap-meter-label">
        {t('vault.capMeter', '{{items}} of {{max}} items in your cloud vault', { items: cap.items, max: cap.max })}
      </div>
      <div className="vault-cap-meter-track" aria-hidden="true">
        <div className={`vault-cap-meter-fill${cap.nearlyFull ? ' is-warn' : ''}`} style={{ width: `${pct}%` }} />
      </div>
      {hint && (
        <div className="vault-cap-meter-hint">
          {hint}{' '}
          <button type="button" className="vault-cap-meter-link" onClick={() => setPlanModalOpen(true)}>
            {t('vault.capUpgradeShort', 'Upgrade')}
          </button>
        </div>
      )}
    </div>
  );
}
